<template>
  <div style="padding-top: 12px;">
    <div style="display: flex;">
      <div class="title" style="flex: 1;">Other Documents</div>
      <a :disabled="!dataList || dataList.length == 0" class="edit-icon" @click="handleEdit" :style="{color: dataList.some(p=>p.isEditable) ? '#333' : ''}" v-if="!isShowEdit">
        <a-icon :type="dataList.some(p=>p.isEditable) ? 'close' : 'edit'" />
      </a>
    </div>
    <div class="ant-table ant-table-scroll-position-left ant-table-default">
      <div class="ant-table-content">
        <div class="ant-table-body">
          <table>
            <thead class="ant-table-thead">
              <tr>
                <th class="ant-table-row-cell-break-word" v-if="!isMainShow">
                  <a-checkbox 
                    :disabled="!this.dataList || this.dataList.length == 0"
                    :indeterminate="indeterminate" 
                    :checked="checkAll" 
                    @change="onCheckAllChange" 
                  />
                </th>
                <th class="ant-table-row-cell-break-word upload-flag-col">#</th>
                <th class="ant-table-row-cell-break-word">Document Type</th>
                <th class="ant-table-row-cell-break-word">Surname</th>
                <th class="ant-table-row-cell-break-word">Given Names</th>
                <th class="ant-table-row-cell-break-word">Document No</th>
                <th class="ant-table-row-cell-break-word">Expiration Date</th>
                <th class="ant-table-row-cell-break-word">DOB</th>
                <th class="ant-table-row-cell-break-word" v-if="!isShowEdit"></th>
              </tr>
            </thead>
            <tbody class="ant-table-tbody">
              <template v-for="(p, pindex) in dataList">
                <tr class="ant-table-row" :key="p.id + '-' + pindex">
                  <td v-if="!isMainShow">
                    <a-checkbox 
                      :checked="p.checked" 
                      @change="e => onCheckChange(e, pindex)" 
                    />
                  </td>
                  <td class="upload-flag-cell">
                    <a-icon
                      v-if="String(p.documentFlag || '') === '1'"
                      type="idcard"
                      class="document-flag-icon"
                    />
                  </td>
                  <td>
                    <div v-if="!p.isEditable" :title="p.ifOther == 2 ? 'ID-' + (p.country ? p.country.code : '') : (p.country ? p.country.nameEnUs : '')" style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ p.ifOther == 2 ? 'ID-' + (p.country ? p.country.code : '') : (p.country ? p.country.nameEnUs : '') }}
                    </div>
                    <template v-else>
                      <a-select
                        @change="value => handleDocumentTypeChange(p, value)"
                        :value="p.documentType == '' ? p.documentType : p.countryId"
                        allowClear
                        :dropdownMatchSelectWidth="false"
                        style="width: 100px;"
                        :showSearch="true"
                        optionFilterProp="children"
                      >
                        <a-select-option value="">ID</a-select-option>
                        <a-select-option v-for="i in PassportTravelDocList.filter(item => item.ifOther == 1)" :key="'country-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
                      </a-select>
                      <a-select
                        v-if="p.documentType == '' || p.countryId == ''"
                        allowClear
                        :dropdownMatchSelectWidth="false"
                        style="width: 100px;"
                        :showSearch="true"
                        optionFilterProp="children"
                        :value="p.countryCode"
                        @change="value => handleCountryCodeChange(p, value)"
                      >
                        <a-select-option v-for="(i, index) in PassportTravelDocList.filter(item => item.ifOther == 0 && idList.includes(item.documentCode))" :key="index"  :value="i.documentCode + '-' + index">{{ i.enName }}</a-select-option>
                      </a-select>
                    </template>
                  </td>
                  <td>
                    <template v-if="!p.isEditable">
                      {{ p.lastName }}
                    </template>
                    <template v-else>
                      <a-input
                        style="width: 140px;"
                        @change="handleNameChange"
                        v-model="p.lastName"
                      />
                    </template>
                  </td>
                  <td>
                    <template v-if="!p.isEditable">
                      {{ p.firstName }}
                    </template>
                    <template v-else>
                      <a-input
                        style="width: 140px;"
                        @change="handleNameChange"
                        v-model="p.firstName"
                      />
                    </template>
                  </td>
                  <td>
                    <template v-if="!p.isEditable">
                      {{ p.passportNumber }}
                    </template>
                    <template v-else>
                      <a-input
                        style="width: 120px;"
                        @change="handlePassportNumberChange"
                        placeholder="Numbers"
                        :maxLength="30"
                        v-model="p.passportNumber"
                      />
                    </template>
                  <td>
                    <template v-if="!p.isEditable">
                      {{ dateFormatB(p.expirationDate) }}
                    </template>
                    <template v-else>
                      <a-input
                        style="width: 110px;"
                        placeholder="mm/dd/yyyy"
                        :maxLength="10"
                        @change="handleDateChange(pindex, 'expirationDate', $event)"
                        @blur="handleInputDateBlur(pindex, 'expirationDate')"
                        v-model="p.expirationDate"
                      />
                    </template>
                  </td>
                  <td>
                    <template v-if="!p.isEditable">
                      {{ dateFormatB(p.birthday) }}
                    </template>
                    <template v-else>
                      <a-input
                        style="width: 110px;"
                        placeholder="mm/dd/yyyy"
                        :maxLength="10"
                        @change="handleDateChange(pindex, 'birthday', $event)"
                        @blur="handleInputDateBlur(pindex, 'birthday')"
                        v-model="p.birthday"
                      />
                    </template>
                  </td>
                  <td v-if="!isShowEdit">
                    <template v-if="!p.isEditable">
                      <a-button type="primary" @click="isOtherModalShow = true" v-if="pindex === (dataList.length-1)"><a-icon type="plus"/> Add New</a-button>
                    </template>
                    <template v-else>
                      <a @click="handlePassportAdd" v-if="pindex === (dataList.length-1)">
                        <a-icon type="plus"/>
                      </a>
                      <a-divider type="vertical" v-if="pindex == (dataList.length - 1) && dataList.length !== 1" />
                      <a-popconfirm
                        title="Are you sure?"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="handlePassportDelete(pindex)"
                      >
                        <a v-if="(pindex !== (dataList.length-1) || pindex === (dataList.length-1)) && dataList.length >1"><a-icon type="delete" style="color:#eb2f96;" /></a>
                      </a-popconfirm>
                    </template>
                  </td>
                </tr>
              </template>
              <tr v-if="dataList.length == 0" class="ant-table-row">
                <td colspan="7" style="text-align: center;" v-if="!isShowEdit"><a-button type="primary" @click="isOtherModalShow = true"><a-icon type="plus"/> Add New</a-button></td>
                <td colspan="7" v-else><a-empty :image="simpleImage" description="No Data" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div style="padding-top: 14px;text-align: right;" v-if="dataList.some(p=>p.isEditable)">
      <a-button type="primary" :loading="saving" @click="handleSave">Save</a-button>
      <a-button @click="handleCancel" style="margin-left: 8px;">Close</a-button>
    </div>
    <a-modal
      title="Add New Document"
      :destroyOnClose="true"
      :visible="isOtherModalShow"
      :maskClosable="false"
      @cancel="() => { this.isOtherModalShow = false, this.handleCancel() }"
    >
      <a-form-model v-for="(form, pindex) in passportForms" :key="pindex" :model="form">
        <a-row :gutter="16">
          <a-col :span="form.documentType == '' ? 6 : 12">
            <a-form-model-item label="Document Type">
              <a-select
                @change="value => handleDocumentTypeChange(form, value)"
                :value="form.documentType == '' ? form.documentType : form.countryId"
                :dropdownMatchSelectWidth="false"
                style="width: 100%;"
                :showSearch="true"
                optionFilterProp="children"
              >
                <a-select-option value="">ID</a-select-option>
                <a-select-option v-for="i in PassportTravelDocList.filter(item => item.ifOther == 1)" :key="'country-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" v-if="form.documentType == ''">
            <a-form-model-item label="Country">
              <a-select
                @change="value => handleCountryCodeChange(form, value)"
                v-model="form.countryCode"
                :dropdownMatchSelectWidth="false"
                style="width: 100%;"
                :showSearch="true"
                optionFilterProp="children"
              >
                <a-select-option v-for="(i, index) in PassportTravelDocList.filter(item => item.ifOther == 0 && idList.includes(item.documentCode))" :key="index"  :value="i.documentCode + '-' + index">{{ i.enName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Document No">
              <a-input
                v-model="form.passportNumber"
                @change="handlePassportNumberChange"
                placeholder="Numbers"
                :maxLength="30"
                ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Surname">
              <a-input @change="handleNameChange" v-model="form.lastName"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Given Name">
              <a-input @change="handleNameChange" v-model="form.firstName"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Expiration Date">
              <a-input
                v-model="form.expirationDate"
                placeholder="mm/dd/yyyy"
                :maxLength="10"
                @change="handleDateChange(pindex, 'expirationDate', $event, 'add')"
                @blur="handleInputDateBlur(pindex, 'expirationDate', 'add')"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="DOB">
              <a-input
                v-model="form.birthday"
                placeholder="mm/dd/yyyy"
                :maxLength="10"
                @change="handleDateChange(pindex, 'birthday', $event, 'add')"
                @blur="handleInputDateBlur(pindex, 'birthday', 'add')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <template slot="footer">
        <a-button type="primary" :loading="saving" @click="handlePassportSave">
          Save
        </a-button>
        <a-button @click="() => { this.isOtherModalShow = false, this.handleCancel() }">
          Close
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import _ from 'lodash'
import moment from 'moment'
import CustomerApi from '@/api/api-cdb-custome-v2'

export default {
  name: 'CdbCustomerOtherDocumentsList',
  components: {
    Empty
  },
  props: {
    otherList: {
      type: [Array],
      default: () => []
    },
    customerId: {
      type: String,
      required: true
    },
    customerBirthday: {
      type: [String],
      default: null
    },
    PassportTravelDocList: {
      type: [Array],
      default: null
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      saving: false,
      dataList: [],
      localCustomerBirthday: null,
      isOtherModalShow: false,
      passportForms: [
        { internalCode: this.generateUuid(), documentType: null, countryId: null, passportNumber: null, firstName: null, lastName: null, middleName: null, expirationDate: null, birthday: null, countryCode: null, documentFlag: 0 }
      ],
      checkAll: false,
      indeterminate: false,
      selectedRow: [],
      idList: ['CHN', 'USA', 'TWN']
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.dataList = this.copyDataByJSON(this.otherList)
      this.localCustomerBirthday = this.customerBirthday ? moment(this.customerBirthday).format('MM/DD/YYYY') : null
      this.passportForms[0].birthday = this.customerBirthday ? moment(this.customerBirthday).format('MM/DD/YYYY') : null
      
      // 修改条件判断 - 只需要检查dataList是否有元素
      if (this.dataList && this.dataList.length > 0) {
        this.dataList.forEach(item => {
          item.isEditable = false
          item.checked = false
          item.expirationDate = item.expirationDate ? moment(item.expirationDate).format('MM/DD/YYYY') : null
          item.birthday = item.birthday ? moment(item.birthday).format('MM/DD/YYYY') : null

          if (item.ifOther == 2) {
            item.documentType = ''
            item.countryCode = item.country.code
          } else {
            item.documentType = item.countryId
            item.countryCode = null
          }
        })
      }
    },
    handlePassportAdd () {
      this.dataList.push({ internalCode: this.generateUuid(), countryId: null, passportNumber: null, firstName: null, lastName: null, middleName: null, expirationDate: null, birthday: this.localCustomerBirthday, isEditable: true, documentFlag: 0 })
      this.$forceUpdate()
    },
    handlePassportDelete (pindex) {
      this.dataList.splice(pindex, 1)
      this.$forceUpdate()
    },
    handleEdit () {
      const isCurrentlyEditing = this.dataList.some(item => item.isEditable)
      this.dataList = this.dataList.map(item => ({
        ...item,
        isEditable: !isCurrentlyEditing
      }))
    },
    handleNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/[^a-zA-Z ]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    handlePassportNumberChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        const newValue = value.replace(/[^\w]/ig,'')
        e.target.value = newValue
      }
    },
    handleDateChange(pindex, name, e, type) {
      const value = e.target.value
      if (value && value !== '') {
        // 1. 移除所有非数字和非斜杠的字符
        let newValue = value.replace(/[^0-9/]/g, '')
        
        // 2. 自动添加斜杠
        if (newValue.length > 2 && newValue.charAt(2) !== '/') {
          newValue = newValue.substring(0, 2) + '/' + newValue.substring(2)
        }
        if (newValue.length > 5 && newValue.charAt(5) !== '/') {
          newValue = newValue.substring(0, 5) + '/' + newValue.substring(5)
        }
        
        // 3. 限制总长度 (mm/dd/yyyy 共10字符)
        if (newValue.length > 10) {
          newValue = newValue.substring(0, 10)
        }
        
        // 4. 更新输入框值
        e.target.value = newValue
        if (type === 'edit') {
          this.dataList[pindex][name] = newValue
        } else if (type === 'add') {
          this.passportForms[pindex][name] = newValue
        }
        
        // 5. 当输入完整日期时自动验证
        this.$nextTick(() => {
          if (newValue.length === 10) {
            this.handleInputDateBlur(pindex, name)
          }
        })
      }
    },
    handleInputDateBlur (pindex, name, type) {
      let value = null
      if (type === 'edit') {
        value = this.dataList[pindex][name]
      } else if (type === 'add') {
        value = this.passportForms[pindex][name]
      }
      if (value && value !== '') {
        const momentDate = moment(value, 'MM/DD/YYYY', true)
        if (!momentDate.isValid()) {
          if (type === 'edit') {
            this.dataList[pindex][name] = null
          } else if (type === 'add') {
            this.passportForms[pindex][name] = null
          }
        }
      }
    },
    handleSave () {
      this.saving = true
      const validatedData = this.dataList.map(item => {
        const ifOther = this.isStrEmpty(item.documentType) ? 2 : 1
        return {
          ...item,
          documentFlag: String(item.documentFlag || '') === '1' ? 1 : 0,
          ifOther,
          country: this.getPassportTravelDoc(item.countryId),
          expirationDate: item.expirationDate ? moment(item.expirationDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
          birthday: item.birthday ? moment(item.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD') : null
        }
      })
      CustomerApi.saveTravelDocuments({ passportList: [], otherPassportList: validatedData }, this.customerId).then(res => {
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.mixinProcessSuccessNotification('Save success !')
          this.$emit('update')
          this.handleCancel()
          this.saving = false
        }
      }).catch(() => {
        this.saving = false
      })
    },
    handleCancel () {
      this.passportForms = [
        { 
          internalCode: this.generateUuid(), 
          countryId: null, 
          passportNumber: null, 
          firstName: null, 
          lastName: null, 
          middleName: null, 
          expirationDate: null, 
          birthday: this.localCustomerBirthday,
          documentFlag: 0
        }
      ]
      this.loadData()
    },
    getPassportTravelDoc (id) {
      const passportTravelDocList = this.passportTravelDocList
      if (passportTravelDocList && passportTravelDocList.length > 0) {
        for(let i=0; i < passportTravelDocList.length; i++) {
          const c = passportTravelDocList[i]
          if (id === c.code) {
            return {
              id: c.code,
              code: c.enName,
              nameEnUs: c.enName
            }
          }
        }
        return null
      } else {
        return null
      }
    },
    handlePassportSave () {
      this.saving = true
      const currentForm = this.passportForms[0]
      const validatedData = [
        {
          ...currentForm,
          documentFlag: String(currentForm.documentFlag || '') === '1' ? 1 : 0,
          ifOther: this.isStrEmpty(currentForm.documentType) ? 2 : 1,
          country: this.getPassportTravelDoc(currentForm.countryId),
          expirationDate: currentForm.expirationDate ? moment(currentForm.expirationDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
          birthday: currentForm.birthday ? moment(currentForm.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD') : null
        },
        ...this.dataList
          .filter(item => !item.isEditable)
          .map(item => ({
            ...item,
            documentFlag: String(item.documentFlag || '') === '1' ? 1 : 0,
            ifOther: item.ifOther ? item.ifOther : (this.isStrEmpty(item.documentType) ? 2 : 1),
            country: item.country || this.getPassportTravelDoc(item.countryId),
            expirationDate: item.expirationDate  ? moment(item.expirationDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
            birthday: item.birthday ? moment(item.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD') : null
          }))
      ]
      CustomerApi.saveTravelDocuments(
        { passportList: [], otherPassportList: validatedData }, this.customerId).then(res => {
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.mixinProcessSuccessNotification('Save success !')
          this.$emit('update')
          this.handleCancel()
          this.isOtherModalShow = false
          this.saving = false
        }
      }).catch(() => {
        this.saving = false
      })
    },
    onCheckAllChange (e) { 
      const checked = e.target.checked
      this.dataList.forEach(item => {
        item.checked = checked
      })
      this.checkAll = checked
      this.indeterminate = false

      if (checked) {
      this.selectedRow = this.dataList.filter(item => item.checked)
    } else {
      this.selectedRow = []
    }
    },
    onCheckChange (e, index) {
      const checked = e.target.checked
      this.dataList[index].checked = checked
      const checkedCount = this.dataList.filter(item => item.checked).length
      this.checkAll = checkedCount === this.dataList.length
      this.indeterminate = checkedCount > 0 && checkedCount < this.dataList.length
      this.selectedRow = this.dataList.filter(item => item.checked)
      this.$forceUpdate()
    },
    handleDocumentTypeChange (form, value) { 
      form.countryId = value
      if (this.isStrEmpty(value)) {
        form.documentType = ''
        form.countryCode = 'USA'
        this.handleCountryCodeChange(form, 'USA-0')
      } else {
        form.documentType = value
        form.countryCode = null
      }
    },
    handleCountryCodeChange (form, value) { 
      const documentCode = value.split('-')[0]
      const selectedCountry = this.PassportTravelDocList.find(item => 
        item.ifOther == 2 && item.documentCode == documentCode
      )
      if (selectedCountry) {
        form.countryId = selectedCountry.code
        form.countryCode = documentCode
      } else {
        form.countryId = null
        form.countryCode = null
      }
      this.$forceUpdate()
    },
  },
  watch: {
    otherList: {
      immediate: true,
      handler() {
        this.loadData()
      }
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
  margin-bottom: 6px;
}
.edit-icon {
  font-size: 16px;
}
.upload-flag-col,
.upload-flag-cell {
  width: 34px;
  min-width: 34px;
  max-width: 34px;
  text-align: center;
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.document-flag-icon {
  font-size: 13px;
  color: #1890ff;
}
</style>
